const loadingDotsTemplate = require('./../../shared/templates/loading-dots-row-template.handlebars');
const alertTemplate = require('./../../shared/templates/dismissible-alert-template.handlebars');
const alertSignupModalTemplate = require('./alert-signup-modal-template.handlebars');
const alertSignupModalMobileConfirmationTemplate = require('./alert-signup-modal-mobile-confirmation-template.handlebars');
const Inputmask = require('inputmask');
var AlertSignupService = new alertSignupService();

$(function () {

    if (!$('#alert-signup-modal').length) return;
    let $modal = $('#alert-signup-modal');

    $modal.on('show.bs.modal', function () {
        initializeAlertSignupModal($modal);
    });
    $modal.on('hide.bs.modal', function () {
        unbindAlertSignupModalEvents();
        unbindMobileConfirmationEvents();
    });

    //WTS 9/21/20 Listrak Switch
    $('.as-mobile-confirmation-container #as-mobile-number').mouseout(function () {
        if (inputFormatIsValid($(this), /^\(?\d{3}\)?[- ]?\d{3}[- ]?\d{4}$/)) {
            $(this).val($(this).val());
        } 
    });

    enableMobileOptions();//WTS 9/21/20 Listrak Switch
});

function inputFormatIsValid(element, pattern) {
    return pattern.test($(element).val());
}

function initializeAlertSignupModal($modal) {
    var loadingDots = loadingDotsTemplate();
    $modal.find('#alert-signup-form-container .modal-body').html(loadingDots);

    //let userId = $('#alert-user-id').val();   ////RCW 3/27/20
    let emailAddress = $('#alert-email').val();
    let ipAddress = $('#alert-ipAddress').val();

    // changed below (!userId) to (!emailAddress)   ////RCW 3/27/20
    if (!emailAddress) {
        $modal.find('#alert-signup-form-container').addClass("hidden");
        $modal.find('#alert-signup-confirmation-container').addClass("hidden");
        $modal.find('#alert-signup-not-logged-in-container').removeClass("hidden");
    } else {
        $modal.find('#alert-signup-form-container').removeClass("hidden");
        $modal.find('#alert-signup-confirmation-container').addClass("hidden");
        $modal.find('#alert-signup-not-logged-in-container').addClass("hidden");
        //getInitialAlertSignupData($modal, userId, emailAddress, ipAddress);   //original RCW 3/27/20
        getInitialAlertSignupData($modal, emailAddress, ipAddress);   //// New RCW 3/27/20

    }
}
//url: `/api/v1/alertsInfo?userId=${userId}&emailaddress=${emailAddress}`  ////Removed the parms call
function getInitialAlertSignupData($modal, emailAddress, ipAddress) {

    $.ajax({
        url: `/api/v1/alertsInfo`,
        type: 'GET'
    })
        .done(function (data) {

            AlertSignupService.initialData = data;
            AlertSignupService.initialData.NewData.IpAddress = ipAddress;

            var html = alertSignupModalTemplate({ data: data.OldData });
            $modal.find('#alert-signup-form-container .modal-body').html(html);

            if (AlertSignupService.initialData.OldData.UserAlertInfo.Jackpot_DropdownValue != 0) {
                document.getElementById("Jackpot_DropdownValue").value = AlertSignupService.initialData.OldData.UserAlertInfo.Jackpot_DropdownValue;
            }

            bindAlertSignupModalEvents($modal);

            updateMobileConfirmationDisplay();
        });
}

function bindAlertSignupModalEvents($modal) {
    $('#as-modal-submit').on('click', function () {
        postAlertSignupData($modal);
    });

    $("#as-enableAllAlerts").on('click', function () {
        $("#alert-signup-form-container input[type=checkbox]").prop("checked", true);
        document.getElementById("Jackpot_DropdownValue").selectedIndex = 1;
    });

    $("#as-disableAllAlerts").on('click', function () {
        $("#alert-signup-form-container input[type=checkbox]").prop("checked", false);
        document.getElementById("Jackpot_DropdownValue").selectedIndex = 0;
    });
}
function unbindAlertSignupModalEvents() {
    //$('#as-modal-submit').off('click'); WTS 9/18/20 Listrak Switch
    $('#as-enableAllAlerts').off('click');
    $('#as-disableAllAlerts').off('click');
}

function updateMobileConfirmationDisplay() {
    unbindMobileConfirmationEvents();

    var html = alertSignupModalMobileConfirmationTemplate({ mobileNumberInfo: AlertSignupService.initialData.NewData.MobileNumberInfo });
    $('#alert-signup-modal #alert-signup-form-container #as-mobile-signup-primary-container').html(html);

    bindMobileConfirmationEvents();
}
function initializeMobileNumberInputMask() {
    var selector = document.getElementById("as-mobile-number");
    if (selector)
        Inputmask({ "mask": "999-999-9999" }).mask(selector);
}
function initializeConfirmationCodeInputMask() {
    var selector = document.getElementById("as-confirmation-code");
    if (selector)
        Inputmask({ "mask": "9999" }).mask(selector);
}
function bindMobileConfirmationEvents() {

    initializeMobileNumberInputMask();
    initializeConfirmationCodeInputMask();

    //STEP 1: RequestConfirmationCode
	//RCW 3/19/20 REMOVED - the input (code) from the api call 
    $("#as-mobile-signup-primary-container #as-mobile-number-requestConfirmationCode").on('click', function () {
        let $mobileNumberValidationContainer = $('#as-mobile-number-validation-container')
        $mobileNumberValidationContainer.empty();

        //GET PHONE NUMBER FROM DOM AND VALIDATE/STRIP DASHES
        AlertSignupService.initialData.NewData.PhoneNumber = $("#as-mobile-signup-primary-container #as-mobile-number").val().replace(/\D+/g, '');

        //GENERATE 4 DIGIT CODE
        //AlertSignupService.confirmationCode = Math.floor(1000 + Math.random() * 9000);  //RCW 3/19/20

        if (AlertSignupService.initialData.NewData.PhoneNumber.length === 10) {


            $.ajax({
                url: `/api/v1/mobileconfirmation?phonenumber=${AlertSignupService.initialData.NewData.PhoneNumber}`,
                type: 'GET'
            })
                .fail(function (jqXHR, textStatus, errorThrown) {
                    displayValidationAlert({ message: `${errorThrown}`, severity: { error: true } }, $mobileNumberValidationContainer);
                })
                .done(function (data) {
                    updateMobileConfirmationData(false, AlertSignupService.initialData.NewData.PhoneNumber);
                    updateMobileConfirmationDisplay();
                    //updateMobileCheckboxOptionAvailability();
                });
        } else {
            displayValidationAlert({ message: `Invalid Phone Number`, severity: { error: true } }, $mobileNumberValidationContainer);
        }
    });

    //STEP 2: SubmitConfirmationCode
	//RCW 3/19/20 ADDED - the input (code) to the api call  also removed === AlertSignupService.confirmationCode) from the if statement
	
    $("#as-mobile-signup-primary-container #as-confirmation-code-submitConfirmationCode").on('click', function () {

        let $confirmationCodeValidationContainer = $('#as-confirmation-code-validation-container');
        $confirmationCodeValidationContainer.empty();

        let userEnteredConfirmationCode = parseInt($('#as-confirmation-code').val());
           AlertSignupService.confirmationCode = userEnteredConfirmationCode 
        
		if (AlertSignupService.confirmationCode > 1) {

            $.ajax({
                url: `/api/v1/confirmmobile?phonenumber=${AlertSignupService.initialData.NewData.PhoneNumber}&code=${userEnteredConfirmationCode}&userid=${AlertSignupService.initialData.NewData.UserId}&ipaddress=${AlertSignupService.initialData.NewData.IpAddress}`,
                type: 'GET'
            })
                .fail(function (jqXHR, textStatus, errorThrown) {
                    displayValidationAlert({ message: `${errorThrown}`, severity: { error: true } }, $confirmationCodeValidationContainer);
                })
                .done(function (data) {
                    updateMobileConfirmationData(true, AlertSignupService.initialData.NewData.PhoneNumber);
                    updateMobileConfirmationDisplay();
                    //updateMobileCheckboxOptionAvailability();
                });
        } else {
            //Confirmation Code doesnt match
            displayValidationAlert({ message: `Invalid Confirmation Code`, severity: { error: true } }, $confirmationCodeValidationContainer);
        }
    });

    //STEP 3: Change Phone Number
    $("#as-mobile-signup-primary-container #as-mobile-number-changeMobileNumber").on('click', function () {
        updateMobileConfirmationData(false, null);
        updateMobileConfirmationDisplay();
        //updateMobileCheckboxOptionAvailability();
        $('#as-mobile-number').prop('disabled', false);
    });
}
function unbindMobileConfirmationEvents() {
    $("#as-mobile-signup-primary-container #as-mobile-number-requestConfirmationCode").off('click');
    $("#as-mobile-signup-primary-container #as-confirmation-code-submitConfirmationCode").off('click');
    $("#as-mobile-signup-primary-container").off('click');
}
function updateMobileConfirmationData(isConfirmed, phonenumber) {
    AlertSignupService.initialData.NewData.MobileNumberInfo.IsConfirmed = isConfirmed;
    AlertSignupService.initialData.NewData.MobileNumberInfo.PhoneNumber = phonenumber;
    AlertSignupService.initialData.NewData.MobileNumberInfo.PhoneNumberWithDashes = null;
}
function updateMobileCheckboxOptionAvailability() {
    //WTS 9/21/20 Listrak Switch
    //if (AlertSignupService.initialData.NewData.MobileNumberInfo.IsConfirmed) {
        //enableMobileOptions();
    //} else {
        //disableMobileOptions();  
        //uncheckMobileOptions();
}

function mapUserEnteredData() {

    //WTS 9/21/20 Listrak Switch
    var phoneNumber = $(".as-mobile-confirmation-container #as-mobile-number").val().replace(/\D+/g, '');

    let newUserEnteredData = {
        "NewData": {
            //"UserId": AlertSignupService.initialData.OldData.UserId.toString(),  //// RCW 3/27/20
            "EmailAddress": AlertSignupService.initialData.OldData.EmailAddress,
            "IpAddress": AlertSignupService.initialData.NewData.IpAddress,
            "MobileNumberInfo": {// WTS 9/21/20 Added MobileNumberInfo to capture the changed phone number if it exists 
                "PhoneNumber": phoneNumber
            },
            "UserAlertInfo": {
                "Jackpot_Mobile": document.getElementById('Jackpot_Mobile').checked,
                "Jackpot_Email": document.getElementById('Jackpot_Email').checked,
                "Jackpot_DropdownValue": document.getElementById('Jackpot_DropdownValue').value,
                //"FreeTickets_USMail": document.getElementById('FreeTickets_USMail').checked,
                //"FreeTickets_Email": document.getElementById('FreeTickets_Email').checked,
                "LatestNews_Mobile": document.getElementById('LatestNews_Mobile').checked,
                "LatestNews_Email": document.getElementById('LatestNews_Email').checked,
                "Pick345_Mobile": document.getElementById('Pick345_Mobile').checked,
                "Pick345_Email": document.getElementById('Pick345_Email').checked,
                "Powerball_Mobile": document.getElementById('Powerball_Mobile').checked,
                "Powerball_Email": document.getElementById('Powerball_Email').checked,
                "MegaMillions_Mobile": document.getElementById('MegaMillions_Mobile').checked,
                "MegaMillions_Email": document.getElementById('MegaMillions_Email').checked,
                "BankMillion_Mobile": document.getElementById('BankMillion_Mobile').checked,
                "BankMillion_Email": document.getElementById('BankMillion_Email').checked,
                "Cash4Life_Mobile": document.getElementById('Cash4Life_Mobile').checked,
                "Cash4Life_Email": document.getElementById('Cash4Life_Email').checked
            }
        }
    };

    return $.extend(true, AlertSignupService.initialData, newUserEnteredData);
}

function postAlertSignupData($modal) {

    var userEnteredData = mapUserEnteredData();
    var isValid = validateAlertSignupForm();

    //WTS 10/6/20 Added code below to set the form validity to invalid if a mobile option is selected, but no mobile number is entered
    if ($('.isMobileOption').is(':checked')) {
        isValid = $(".as-mobile-confirmation-container #as-mobile-number").val().length > 0;

        if (!isValid) {
            $('#lbl-mobile-required').show();
        } else {
            $('#lbl-mobile-required').hide();
        }
    }

    if (isValid) {
        $.ajax({
            url: '/api/v1/alertsInfo',
            type: 'POST',
            data: userEnteredData,
            dataType: 'text'
        })
            .done(function () {
                $modal.find('#alert-signup-form-container').addClass("hidden");
                $modal.find('#alert-signup-confirmation-container').removeClass("hidden");
            });
    } else {
        //TODO: Show validation message somewhere? Handle this inside validateAlertSignupForm() ??
    }
}

function enableMobileOptions() {
    let $mobileCheckboxes = $('.isMobileOption');
    $mobileCheckboxes.removeAttr('disabled');
    $mobileCheckboxes.removeClass('disabled');
}
function disableMobileOptions() {
    let $mobileCheckboxes = $('.isMobileOption');
    $mobileCheckboxes.attr('disabled', true);
    $mobileCheckboxes.addClass('disabled');
}
function uncheckMobileOptions() {
    let $mobileCheckboxes = $('.isMobileOption');
    $mobileCheckboxes.prop('checked', false);
}

function validateAlertSignupForm() {
    let $jackpotThresholdValidationContainer = $('#as-jackpot-threshold-validation-container');
    $jackpotThresholdValidationContainer.empty();

    let errors = [];

    if ((AlertSignupService.initialData.NewData.UserAlertInfo.Jackpot_Mobile || AlertSignupService.initialData.NewData.UserAlertInfo.Jackpot_Email)
        && AlertSignupService.initialData.NewData.UserAlertInfo.Jackpot_DropdownValue == "") {

        let alertObject = {
            message: `Please choose a High Jackpot Alert limit.`,
            severity: { error: true }
        };

        $('#Jackpot_DropdownValue').addClass('invalid');
        displayValidationAlert(alertObject, $jackpotThresholdValidationContainer);

        errors.push(alertObject);
    } else {
        $('#Jackpot_DropdownValue').removeClass('invalid');
    }

    return !errors.length;
}

function displayValidationAlert(alert, $container) {
    let html = alertTemplate({ alertData: alert });
    $container.append(html);
}

function alertSignupService(options) {
    //var alertSignupDefaultOptions = {};
    //this.options = $.extend(true, alertSignupDefaultOptions, options);

    this.initialData = undefined;
    this.confirmationCode = undefined;
}


// WEBPACK FOOTER //
// ./features/alert-signup/alert-signup.js